import { Container, Row, Col } from 'react-bootstrap';
import Breadcrumbs from '../../../../ntisui/Atoms/Breadcrumb';

import { breadcrumbsLinks } from '../../../../../constants/Constants';

const CookiesPolicy = () => {
  return (
    <Container className="main-container p-0">
      <Row>
        <Col xs={12} md={8}>
          <Breadcrumbs links={breadcrumbsLinks.cookiesPolicy} />
          <h3 className="main-heading" data-testid="Cookies Policy">
            Cookies Policy
          </h3>
          <div className="main-content">
            <p>
              We use cookies to store information about how you use our website,
              such as the pages you visit or to remember your settings and
              preferences.Cookies are files saved on your phone, tablet or
              computer when you visit a website.
            </p>
            <h3>Cookie settings</h3>
            <p>We use three types of cookie on this website:</p>
            <p>
              <b>Strictly necessary cookies</b>- These enable core
              functionality, such as page navigation and access to secure areas.
              The website can't function properly without them so can't be
              switched off here. They can only be disabled by changing your
              browser preferences and we can't guarantee our website will work
              for you if you do this.
            </p>
            <p>
              <b>Analytical cookies</b>- These help us to improve our website by
              collecting and reporting information on its usage.
            </p>
            <p>
              <b>Marketing and communications cookies</b>- These may be set by
              third-party websites that we use and do things like measure how
              you view our YouTube videos or use our GovMetrics feedback and
              BrowseAloud services etc. You can switch these off if you don't
              want us to collect this data about you.
            </p>
            <h3>Managing cookies</h3>
            <p>
              You can adjust your cookie settings when using our website by
              clicking on the 'Cookie Preferences' button on the bottom right of
              the website. This can be accessed on every page.
            </p>
            <p>
              If you’d like to learn more about cookies and how to remove them,
              visit: AboutCookies.org.uk or the Information Commissioner's
              Office: Cookies.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default CookiesPolicy;
